export default "__VITE_ASSET__En6EDxWj__"